const SELECTOR = "#SubCategoryList"

let captured: Element | null = null

export function captureSubCategoryList(root: HTMLElement) {
  captured = root.querySelector(SELECTOR)
}

export function consumeSubCategoryList() {
  const element = captured
  captured = null
  return element
}
